function initHpShopSwiper() {
  const swiperContainer = document.querySelector(".swiper-hp-shop");
  if (!swiperContainer) return;

  const productCount = parseInt(swiperContainer.dataset.productCount) || 0;
  const isDesktop = window.innerWidth >= 768;

  // On mobile: always enable swiper
  // On tablet/desktop: only enable swiper if more than 3 items
  const shouldEnableSwiper = !isDesktop || productCount > 3;

  if (shouldEnableSwiper) {
    return new Swiper(".swiper-hp-shop", {
      loop: productCount > 1,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 16,

      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 0,
        },
      },
    });
  }
  return null;
}

let swiperHpShop = initHpShopSwiper();

// Re-initialize on resize to handle breakpoint changes
let resizeTimer;
window.addEventListener("resize", function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    if (swiperHpShop) {
      swiperHpShop.destroy(true, true);
    }
    swiperHpShop = initHpShopSwiper();
  }, 250);
});
